import { gql } from '@apollo/client';

import { Server } from '../../apollo/types';
import { useAppDependenciesContext } from '../../state';

type MomentumPilotPatientFeatureAccess = {
  key: string;
  enabled: boolean;
  disabledReasons: {
    disabledByType: string;
  }[];
};

type MomentumPilotAccessForPatientQuery = {
  momentumPilotFeatureForPatient: MomentumPilotPatientFeatureAccess;
};

type MomentumPilotAccessForPatientQueryVariables = {
  patientShortId: string;
  key: string;
  appVersion?: string;
  shouldSkipAppVersionCheck?: boolean;
};

export const MOMENTUM_PILOT_ACCESS_QUERY = gql`
  query MomentumPilotFeatureForPatient(
    $patientShortId: String!
    $key: String!
    $appVersion: String
    $shouldSkipAppVersionCheck: Boolean
  ) {
    momentumPilotFeatureForPatient(
      patientShortId: $patientShortId
      key: $key
      appVersion: $appVersion
      shouldSkipAppVersionCheck: $shouldSkipAppVersionCheck
    ) {
      key
      enabled
      disabledReasons {
        disabledByType
      }
    }
  }
`;

export function useMomentumPilotPatientAccessQuery({
  patientShortId,
  key,
  appVersion,
  shouldSkipAppVersionCheck,
  skip,
}: {
  patientShortId: string;
  key: string;
  appVersion?: string;
  shouldSkipAppVersionCheck?: boolean;
  skip?: boolean;
}) {
  const { useQuery } = useAppDependenciesContext();

  const isMissingRequiredAppVersion = !shouldSkipAppVersionCheck && !appVersion;

  const { data, loading, error } = useQuery<
    MomentumPilotAccessForPatientQuery,
    MomentumPilotAccessForPatientQueryVariables
  >(MOMENTUM_PILOT_ACCESS_QUERY, {
    variables: {
      patientShortId,
      key,
      appVersion,
      shouldSkipAppVersionCheck,
    },
    skip: !patientShortId || !key || isMissingRequiredAppVersion || skip,
    context: {
      server: Server.MONOLITH,
    },
  });

  return {
    pilotAccess: data?.momentumPilotFeatureForPatient,
    loading,
    error,
  };
}
